import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=0cf22560&scoped=true"
import script from "./AppComponent.vue?vue&type=script&lang=js"
export * from "./AppComponent.vue?vue&type=script&lang=js"
import style0 from "./AppComponent.vue?vue&type=style&index=0&id=0cf22560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf22560",
  null
  
)

export default component.exports